module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "dashboard_index"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(_vm._s(_vm.$t('index.terStatus')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/terList"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), (_vm.devData) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio green",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(1)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/online_dev.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.zx) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.onlineTer')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio orange",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(2)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/offline_dev.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.lx) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.offLineTer')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio pink",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(null)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/warn_dev.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.yj) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.warnTer')))])])])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taskData) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(_vm._s(_vm.$t('index.taskList')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/mision-list"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio blue",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/app_push.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.yy))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.pullApp')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio blue let",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/rom_update.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.rom))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.romUpdate')))])])])]), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio green let",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/ad_push.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.gg))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.pullAdvert')))])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.infoData) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(_vm._s(_vm.$t('index.infoList')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/warn"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12,
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "el-card-radio pink dark",
    on: {
      "click": function($event) {
        _vm.jump('/warn')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/rish_warn.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.infoData.fk))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.riskWarn')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12,
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "el-card-radio orange dark",
    on: {
      "click": function($event) {
        _vm.jump('/warn')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard/stoppage_warn.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.infoData.gz))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.breakWarn')))])])])])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7ffe66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = 1051
// module chunks = 0